import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import ValidityAdornment from './ValidityAdornment';
import CtnLang from './CtnLang';

const NotifyObjectLabel = ({ contentValidity }) => {
  const { t } = useTranslation();

  return (
    <div style={{ display: 'flex' }}>
      <Typography
        color={contentValidity.contentIsEmpty ? 'error' : 'textSecondary'}
        style={{
          margin: '5px 10px',
        }}
        variant="subtitle2"
        noWrap
      >
        {t('smartmessaging.contentEditor.notify.object')}
      </Typography>
      <ValidityAdornment
        valid={!contentValidity.objectIsEmpty}
        message={t('smartmessaging.contentEditor.notify.objectIsEmpty')}
      />

      <div style={{ marginRight: 0, marginLeft: 'auto' }}>
        <CtnLang />
      </div>
    </div>
  );
};

NotifyObjectLabel.propTypes = {
  contentValidity: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  contentValidity: state.massAction.contentValidity,
});

export default connect(mapStateToProps)(NotifyObjectLabel);
